// extracted by mini-css-extract-plugin
export default {"delete":"src-pages-SalesChannelContentEditor-SalesChannelEditorProfilePage-revamp-Policy-InputAndLink-css-module__delete--W+TJJ"};